import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'

import { AuthSelectors } from '@app/modules/Auth'
import { getCourtCasesTablePath } from '@app/modules/CourtCasesTables/paths'
import { NavBarEntry } from '@app/NavBar'
import { useNavBarCountersLazyQuery } from '@app/queries/NavBar/NavBarCounters.queries'

export function useNavbarEntries(): NavBarEntry[] {
  const lawyerId = useSelector(AuthSelectors.getUserId)
  const location = useLocation()

  const [count, { data }] = useNavBarCountersLazyQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      lawyerId
    }
  })

  useEffect(() => {
    count()
  }, [location])

  return [
    {
      counter: data?.courtCaseTasks ?? 0,
      iconName: 'gavelWhite',
      title: 'Gerichtsfälle',
      EntryWrapper: ({ children }) => <Link to={getCourtCasesTablePath()}>{children}</Link>,
      active: /^\/gerichtsfaelle/
    }
  ]
}
